import type { DeepRequired } from '../fixtures.types'

const template: DeepRequired<Template> = {
  __typename: 'Template',
  id: 'TEST_ID',
  owning_organisation_id: null,
  allow_child_access: null,
  date_stored: null,
  enforce_for_representative: null,
  file_type: null,
  friendly_name: null,
  is_confidential: null,
  name: null,
  organisation: null,
  render_to: null,
  required_cases: null,
  required_clients: null,
  required_mortgages: null,
  required_organisations: null,
  required_products: null,
  required_users: null,
  styles: null,
  default_style: null,
  sub_type: null,
  template: null,
  template_signature: null,
  updated_by: null,
}

export default template
